import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Box,
    Typography,
    Paper,
    Container,
    Alert,
} from '@mui/material';
import api from '../services/api';
import ResendVerification from '../components/auth/ResendVerification';
import { authFormCardSx, authMarketingShellSx } from '../utils/authMarketingLayout';

const verifyAuthShell = (body: React.ReactNode) => (
    <Box sx={(t) => authMarketingShellSx(t)}>
        <Container
            component="main"
            maxWidth="xs"
            sx={{
                position: 'relative',
                zIndex: 2,
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                py: 3,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {body}
            </Box>
        </Container>
    </Box>
);

const VerifyEmailPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Invalid or missing verification token.');
            return;
        }

        const verifyEmail = async () => {
            try {
                await api.get(`/auth/verify?token=${token}`);
                setSuccess(true);
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } catch (err) {
                setError('Failed to verify email. The link may have expired.');
            }
        };

        verifyEmail();
    }, [token, navigate]);

    return verifyAuthShell(
        <Paper sx={(t) => authFormCardSx(t)}>
            <Typography component="h1" variant="h5" align="center" gutterBottom>
                Email Verification
            </Typography>
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    Email verified successfully! Redirecting to login...
                </Alert>
            )}
            {(error === 'Verification token has expired.' || error === 'Invalid verification token.') && (
                <ResendVerification />
            )}
        </Paper>,
    );
};

export default VerifyEmailPage; 